export const environment = {
  production: true,
  version: require('../../package.json').version,
  backendUrl: 'https://nest.ostriz.cz',
  title: 'OSTŘÍŽ'
};
